import { useState, useEffect } from "react";
import axios from "axios";
import PimpinanLayout from "../../components/layout/PimpinanLayout";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext"; // sesuaikan path

export default function RekapPresensiPimpinan() {
  const { token } = useAuth(); // ← pakai session token

  const [data, setData] = useState([]);
  const [listKelas, setListKelas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    tipe: "harian",
    id_kelas: "",
    tanggal: new Date().toISOString().split("T")[0],
    start: "",
    end: "",
    bulan: "",
  });

  // ===== GET LIST KELAS =====
  useEffect(() => {
    const fetchKelas = async () => {
      try {
        const res = await axios.get("https://backend.smpn1kamal.sch.id/api/kelas", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = res.data.data || res.data;
        setListKelas(data);
      } catch {
        toast.error("Gagal mengambil daftar kelas");
      }
    };

    fetchKelas();
  }, [token]);

  // ===== GET DATA =====
  const handleSubmit = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        "https://backend.smpn1kamal.sch.id/api/presensi/rekap-global",
        {
          params: form,
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setData(res.data);
    } catch {
      toast.error("Gagal ambil rekap");
    } finally {
      setLoading(false);
    }
  };

  // ===== DOWNLOAD =====
  const downloadFile = async (format) => {
    try {
      const res = await axios.get(
        `https://backend.smpn1kamal.sch.id/api/presensi/rekap-global/${format}`,
        {
          params: form,
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `rekap-${form.tipe}-${format}.${format === "excel" ? "xlsx" : "pdf"}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      toast.error(`Gagal download ${format.toUpperCase()}`);
    }
  };

  return (
    <PimpinanLayout>
      <div className="space-y-4">

        {/* ===== HEADER ===== */}
        <div className="space-y-3">

          {/* DESKTOP */}
          <div className="hidden md:flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-indigo-600">
                Laporan Presensi
              </h1>
              <p className="text-gray-500">SMPN 1 Kamal</p>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => downloadFile("excel")}
                className="bg-green-500 text-white px-5 py-2 rounded-full"
              >
                Unduh Excel
              </button>
              <button
                onClick={() => downloadFile("pdf")}
                className="bg-red-500 text-white px-5 py-2 rounded-full"
              >
                Unduh PDF
              </button>
            </div>
          </div>

          {/* MOBILE */}
          <div className="md:hidden space-y-3">
            <div>
              <h1 className="text-2xl font-bold text-indigo-600">
                Laporan Presensi
              </h1>
              <p className="text-gray-500">SMPN 1 Kamal</p>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => downloadFile("excel")}
                className="bg-green-500 text-white px-4 py-2 rounded-full text-sm"
              >
                Unduh Excel
              </button>
              <button
                onClick={() => downloadFile("pdf")}
                className="bg-red-500 text-white px-4 py-2 rounded-full text-sm"
              >
                Unduh PDF
              </button>
            </div>
          </div>
        </div>

        {/* ===== FILTER ===== */}
        <div className="bg-white rounded-2xl shadow-md p-5">
          <div className="flex flex-col md:flex-row gap-3 md:justify-between">

            <div className="flex flex-wrap gap-3">

              {/* KELAS */}
              <select
                value={form.id_kelas}
                onChange={(e) =>
                  setForm({ ...form, id_kelas: e.target.value })
                }
                className="border rounded-full px-4 py-2 text-sm"
              >
                <option value="">Semua Kelas</option>
                {listKelas.map((k) => (
                  <option key={k.id_kelas} value={k.id_kelas}>
                    {k.nama_kelas}
                  </option>
                ))}
              </select>

              {/* TIPE */}
              <select
                value={form.tipe}
                onChange={(e) =>
                  setForm({ ...form, tipe: e.target.value })
                }
                className="border rounded-full px-4 py-2 text-sm"
              >
                <option value="harian">Harian</option>
                <option value="range">Range</option>
                <option value="bulanan">Bulanan</option>
              </select>

              {/* TANGGAL */}
              {form.tipe === "harian" && (
                <input
                  type="date"
                  value={form.tanggal}
                  onChange={(e) =>
                    setForm({ ...form, tanggal: e.target.value })
                  }
                  className="border rounded-full px-4 py-2 text-sm"
                />
              )}

              {form.tipe === "range" && (
                <>
                  <input
                    type="date"
                    onChange={(e) =>
                      setForm({ ...form, start: e.target.value })
                    }
                    className="border rounded-full px-4 py-2 text-sm"
                  />
                  <input
                    type="date"
                    onChange={(e) =>
                      setForm({ ...form, end: e.target.value })
                    }
                    className="border rounded-full px-4 py-2 text-sm"
                  />
                </>
              )}

              {form.tipe === "bulanan" && (
                <input
                  type="month"
                  onChange={(e) =>
                    setForm({ ...form, bulan: e.target.value })
                  }
                  className="border rounded-full px-4 py-2 text-sm"
                />
              )}
            </div>

            <button
              onClick={handleSubmit}
              className="bg-indigo-500 text-white px-5 py-2 rounded-full"
            >
              {loading ? "Loading..." : "Tampilkan"}
            </button>
          </div>
        </div>

        {/* ===== DATA ===== */}
        <div className="bg-white rounded-2xl shadow-md p-5">

          {loading ? (
            <p className="text-center py-6">Loading...</p>
          ) : (
            <>
              {/* MOBILE */}
              <div className="md:hidden space-y-3">
                {data.length === 0 ? (
                  <p className="text-center text-gray-400">
                    Tidak ada data
                  </p>
                ) : (
                  data.map((d, i) => (
                    <div key={i} className="border rounded-xl p-4">
                      <p className="font-semibold">{d.kelas}</p>
                      <p className="text-sm text-gray-500">{d.mapel}</p>
                      <p className="text-sm">{d.guru}</p>
                      <p className="text-sm mt-1 text-indigo-500">
                        {d.keterangan}
                      </p>
                    </div>
                  ))
                )}
              </div>

              {/* DESKTOP */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-3">NO</th>
                      <th className="px-4 py-3 text-left">KELAS</th>
                      <th className="px-4 py-3 text-left">MATA PELAJARAN</th>
                      <th className="px-4 py-3 text-left">GURU</th>
                      <th className="px-4 py-3 text-left">KETERANGAN</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center py-6 text-gray-400">
                          Tidak ada data
                        </td>
                      </tr>
                    ) : (
                      data.map((d, i) => (
                        <tr key={i} className="border-t">
                          <td className="px-4 py-3">{i + 1}</td>
                          <td className="px-4 py-3">{d.kelas}</td>
                          <td className="px-4 py-3">{d.mapel}</td>
                          <td className="px-4 py-3">{d.guru}</td>
                          <td className="px-4 py-3">{d.keterangan}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}

        </div>
      </div>
    </PimpinanLayout>
  );
}